import React from 'react';

import { useHistory } from "react-router-dom";

import { connect } from 'react-redux';
import { Dispatch } from "redux";

import Button from '@material-ui/core/Button';

import { getPageByKey, getPageByIndex, getPageByName, Flow } from '../../service/flowengine/FlowEngineAPI';
import { Page } from "../../service/flowengine/model/Page"

import { RootState } from '../../store/Store';
import { FlowState, updateFlowInputAction } from '../../store/reducers/FlowReducer'


// ---------------------------------------------------
// ---------------------------------------------------
// Properties
// ---------------------------------------------------

type Props = {
    pagename: string;               // base pagename we start with (resp. the breadcrumb is up to)
    categories: boolean;            // each page has a category: if true we build only the breadcrumb of categories (up to current page)
                                    //                           if false, we build up the breadcrumb within the category of current page
}

// we need two portions of properties to have interfaces/types for each redux-mapping-method (mapStateToProps/mapDispatchToProps)
type PropsStatic = {
    flow: Flow
}

type PropsHandler = {
    updateFlowInput(state: FlowState): any,
}


// --------------------------------------------------
// ReactJS knows 2 basic styles of components:
//  - stateful componentes (also called "classes" or "class components"): these components know an internal "state"
//           They are inherited from a class extending React.Component and have a render-method returning the JSX-content
//              export default class Body extends React.Component<BodyProps, BodyState> {}
//
//  - stateless or "function components": these components have no internal state member, but can hold states via useState-hook
//           These components are simply functions returning the JSX content and are written like this
//                  export default function Body(props: BodyProps) { ... return JSX}
//                     or
//                  const Body : React.FunctionComponent<BodyProps> = (props) => {  ... return JSX }
//           Stateless components can maintain states not inherent by an internal state-variable, but by using useState hooks
//


// ---------------------------------------------------
// ---------------------------------------------------
// REDUX store
// ---------------------------------------------------

// Map component-properties to redux-store parts (input is the state, we return the according properties)
// this is the way from redux-store to component-properties
function mapStateToProps(state: RootState): PropsStatic {
  return {
    flow: state.flow.flow,                   // combined state  
  };
}

// Map handler to redux-store actions and place these handler methods into the component-props
// this is the way from component-properties to redux-store (by initiating actions in the redux-store to update it's state)
const mapDispatchToProps = (dispatch: Dispatch): PropsHandler => ({
  updateFlowInput: (state: FlowState) => dispatch(updateFlowInputAction(state)),
});

// Concatenate the two property-type-portions to a single property-type to be used in the component-creation
type FlowComponentProps = Props & PropsStatic & PropsHandler;


// ---------------------------------------------------

// ---------------------------------------------------
// ---------------------------------------------------
// Component
// ---------------------------------------------------
const GenericBreadcrumb : React.FunctionComponent<FlowComponentProps> = (props) => {
    let listInputJSXElement = new Array<JSX.Element>();
    let firstPage: Page | undefined = getPageByIndex(0);   // first page
    let runningPage: Page | undefined = firstPage;
    let elementcounter: number = 0;
    let lastCategory: string = "";

    let currentPage: Page | undefined = getPageByKey(props.pagename);    // page to display

    let history = useHistory();


    // -----------
    // Jump to previous page:
    function gotoPage (pname: number | string) {
        console.log("New page: " + pname);
        history.push('./' + pname);
    }

    function addStep() {
        let width: number = 150;
        const height: number = 20;
        const fontSize: number = 15;
        const strokeWidth: number = 2;

        if(runningPage !== undefined) {
            if(runningPage === firstPage) {
                stepno = 0;
                stepnoCategory = 0;
            }

            if(props.categories === true) {
                // Mode 1:  we want only to display the category of the pages in the breadcrumbs:
                if(lastCategory !== runningPage.category) {   // each category only one time in a row
                    // compute length of element depending of input string:
                    //let elText: JSX.Element = <text x={height + 2} y="27" fontFamily="Verdana" fontSize={fontSize} fill="white"> {runningPage.category}</text>
                    //elText.
                    if(runningPage.category !== undefined)
                        width = (fontSize * 0.75) * runningPage.category.length;

                    listInputJSXElement.push(
                        <svg key={elementcounter++} height={height + height + 8} width={width + height} style={{cursor: "not-allowed", transform: "translate("+ stepnoCategory*-15 + "px, 0px)"}} >
                            <path 
                                //d="m 0 0 h 150 l 20 20 l -20 20 h -150 l 20 -20 z" 
                                d={"m 0 " + strokeWidth + " h " + width + " l " + height + " " + height + " l " + -height + " " + height + " h " + -width + " l " + height + " " + -height + " z"} 
                                stroke="lightgray"
                                fill="lightgray"
                                strokeWidth={strokeWidth}
                            />
                            <text x={height + 2} y="27" fontFamily="Verdana" fontSize={fontSize} fill="white" > 
                                {runningPage.category}
                            </text>
                        </svg>
                    )
                    lastCategory = runningPage.category || "";

                    stepnoCategory++;
                }
            }
            else {
                // or mode 2: we want to display the pagenames inside the category of the page currently displayed.
                if(currentPage !== undefined) {
                    if(runningPage.category === currentPage?.category) {   // if the page running in the loop has the same category than the currently displayed page
                        // compute length of element depending of input string:
                        if(runningPage.label !== undefined)
                            width = (fontSize * 0.75) * runningPage.label.length * 0.9;

                        listInputJSXElement.push(
                            <span key={elementcounter++} onClick={(e) => { if(runningPage !== undefined) gotoPage(runningPage.id) }} >
                                <svg key={elementcounter++} height={height + height + 8} width={width + height} style={{cursor: "pointer", transform: "translate("+ stepno*-15 + "px, 0px)"}} 
                                    >
                                    <path 
                                        //d="m 0 0 h 150 l 20 20 l -20 20 h -150 l 20 -20 z" 
                                        d={"m 0 " + strokeWidth + " h " + width + " l " + height + " " + height + " l " + -height + " " + height + " h " + -width + " l " + height + " " + -height + " z"} 
                                        stroke="#F29401"
                                        fill="#F29401"
                                        strokeWidth={strokeWidth}
                                    />
                                    <text x={height + 2} y="27" fontFamily="Verdana" fontSize={fontSize} fill="white"> 
                                        {runningPage.label}
                                    </text>
                                </svg>
                            </span>
                        )
                        stepno++;
                    }
                    else {
                        stepno = 0;   // new category, so we start from the beginning
                    }
                }
            }
        }
    }


    // we iterate over the pages beginning by the first page and  take all subsequent nextResolver-Pages. 
    // For each page we take the first optional of multiple element according
    // list the contents.
    // Do this until we reach the page currently displayed:
    //addStep();

//    addStep();

    let stepno: number = 0;
    let stepnoCategory: number = 0;
    while(runningPage !== undefined) {
        if(props.pagename === undefined)
            break;

        if((firstPage === undefined) || (currentPage === undefined))
            break;

        // display step for running page:
        addStep();

        // if our page to display is the first page, then leave here:
        if(firstPage.id === currentPage.id)
            break;

        // retrieve next page key to display (via page resolver):
        let nextpagekey: string = runningPage.nextResolver();

        // if next page is the same than the page before: break to avoid infinite loops
        let nextPageToDisplay: Page | undefined = getPageByKey(nextpagekey);
        if(nextPageToDisplay === undefined || nextPageToDisplay.name === runningPage.name)
            break;

        // if the next page is the page currently displayed: just show the step and leave
        runningPage = nextPageToDisplay;

        if(runningPage.id === props.pagename) {
            addStep();
            break;
        }

    }

    // ----
    return (
        <div style={{marginBottom: "10px"}}>
            {listInputJSXElement}
        </div>
    );

}

export default connect(mapStateToProps, mapDispatchToProps)(GenericBreadcrumb);
